import { useContext, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
//Srcs
import "../../../Style/pagestyle.scss";

import EmptyData from "../../../Components/Include/EmptyData";
import LoadingPage from "../../../Utils/LoadingPage";
import { PartyCard } from "./PartyCard/PartyCard";
import { AuthContext } from "../../../Context/AuthContext";
import { useGetPartyAndCandidateNumber } from "../../../Hooks/useGetPartyAndCandidateNumber";

// Helper to determine error state class
export default function TabParty() {
  const { t } = useContext(AuthContext);

  const { tableData, loading, refetch } = useGetPartyAndCandidateNumber();
  useEffect(() => {
    refetch();
  }, []);

  return (
    <Box className="body-container">
      <Grid container spacing={2}>
        {loading ?
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
            <LoadingPage />
          </Grid>
          : tableData?.length === 0 || tableData?.length === undefined ?
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
              <EmptyData />
            </Grid>
            : tableData?.map((e, index) => (
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} key={index}>
                <PartyCard item={e} setRefetch={refetch} />
              </Grid>
            ))}
      </Grid>
    </Box>
  );
}
